import { NgModule } from '@angular/core';

import { ThemeService } from '@innovation-os-ng/ui/viz-tools-ng';
import { TranslateRegistry } from '@itonics/ngx-translate-simple';

import { TimelineUiComponent } from './components/timeline/timeline.component';

import { de } from './i18n/de';
import { en } from './i18n/en';

@NgModule({
  imports: [TimelineUiComponent],
  exports: [TimelineUiComponent],
  providers: [ThemeService]
})
export class ChartNgModule {
  constructor(private translateRegistry: TranslateRegistry) {
    this.translateRegistry.registerLoader((lang) => Promise.resolve({ en, de }[lang] || en));
  }
}
